// Store runtime NÁZVU native oken (dynamický titulek odvozený z načtených dat detailu).
// Klíčováno per layerId; plní ho hook `useWindowTitle` z komponenty detailu, čte hlavička okna,
// taskbar a breadcrumb přes `deriveDesktopProjection`. Native obdoba `legacyWindowChromeStore`
// (legacy titulek se „vycucne" z iframu, native ho publikuje sama agenda po načtení dat).

import { create } from 'zustand';

interface NativeWindowTitleState {
  readonly byLayer: Readonly<Record<string, string>>;
  set: (layerId: string, title: string) => void;
  clear: (layerId: string) => void;
  prune: (layerIds: readonly string[]) => void;
}

export const useNativeWindowTitleStore = create<NativeWindowTitleState>((set) => ({
  byLayer: {},
  // No-op při nezměněném titulku → žádný zbytečný přepočet projekce/re-render konzumentů.
  set: (layerId, title) =>
    set((s) =>
      s.byLayer[layerId] === title ? s : { byLayer: { ...s.byLayer, [layerId]: title } }
    ),
  clear: (layerId) =>
    set((s) => {
      if (!(layerId in s.byLayer)) return s;
      const next = { ...s.byLayer };
      delete next[layerId];
      return { byLayer: next };
    }),
  prune: (layerIds) =>
    set((s) => {
      const keep = new Set(layerIds);
      const ids = Object.keys(s.byLayer);
      if (ids.every((id) => keep.has(id))) return s;
      const next: Record<string, string> = {};
      for (const id of ids) if (keep.has(id)) next[id] = s.byLayer[id] as string;
      return { byLayer: next };
    }),
}));
